import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "banco-overlay"
}
const _hoisted_2 = { class: "banco-contenido" }
const _hoisted_3 = { class: "banco-cabecera" }
const _hoisted_4 = {
  key: 0,
  class: "banco-subtitulo"
}
const _hoisted_5 = { class: "banco-buscador" }
const _hoisted_6 = {
  key: 0,
  class: "banco-lista"
}
const _hoisted_7 = {
  key: 0,
  class: "banco-vacio"
}
const _hoisted_8 = ["checked", "onChange"]
const _hoisted_9 = { class: "banco-item-body" }
const _hoisted_10 = { class: "banco-enunciado" }
const _hoisted_11 = { class: "banco-tag" }
const _hoisted_12 = {
  key: 0,
  class: "banco-opciones"
}
const _hoisted_13 = {
  key: 1,
  class: "banco-grupo"
}
const _hoisted_14 = { class: "banco-footer" }
const _hoisted_15 = { class: "banco-count" }
const _hoisted_16 = { class: "botones" }
const _hoisted_17 = ["disabled"]

import { ref, computed, watch } from 'vue'
import { useGestionBancoPreguntas } from '@/store/GestionBancoPreguntas'
import useAutenticar from '@/store/IngresoAutenticar'
import type Pregunta from '@/interfaces/Preguntas'
import LoadingOverlay from '@/components/LoadingOverlay.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BancoPreguntasSugerenciasModal',
  props: {
    modelValue: { type: Boolean },
    idTipoComponente: {},
    nombreComponente: {}
  },
  emits: ["update:modelValue", "agregar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Sugerencias de preguntas desde el banco y desde la IA.
 *
 * La sugerencia automática es opcional y degrada en silencio: si el proveedor no
 * responde, la lista llega vacía y la pregunta se escribe a mano.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props

const emit = __emit

const bancoStore = useGestionBancoPreguntas()
const authStore = useAutenticar()
const cargando = ref(false)
const busqueda = ref('')
const seleccionadas = ref(new Set<number>())

watch(() => props.modelValue, async (abierto) => {
  if (abierto) {
    busqueda.value = ''
    seleccionadas.value = new Set()
    cargando.value = true
    await bancoStore.cargarBanco()
    cargando.value = false
  }
})

const preguntasFiltradas = computed(() => {
  const q = busqueda.value.toLowerCase().trim()
  if (!q) return bancoStore.preguntasBanco
  return bancoStore.preguntasBanco.filter(p =>
    (p.enunciado || p.pregunta || '').toLowerCase().includes(q)
  )
})

function toggleSeleccion(p: Pregunta) {
  if (p.id_pregunta == null) return
  const next = new Set(seleccionadas.value)
  if (next.has(p.id_pregunta)) {
    next.delete(p.id_pregunta)
  } else {
    next.add(p.id_pregunta)
  }
  seleccionadas.value = next
}

function etiquetaTipo(tipo: string): string {
  const map: Record<string, string> = {
    single_choice: 'Opción única',
    multiple_choice: 'Opción múltiple',
    opcion_multiple: 'Opción múltiple',
    opinion: 'Opinión',
    long_text: 'Respuesta larga',
    texto: 'Texto',
    escala_likert: 'Escala Likert',
    rating: 'Rating',
    numerica: 'Numérica',
  }
  return map[tipo] || tipo
}

function confirmar() {
  const ids = Array.from(seleccionadas.value)
  const elegidas = bancoStore.preguntasBanco.filter(
    p => p.id_pregunta != null && ids.includes(p.id_pregunta)
  )
  emit('agregar', elegidas)
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(LoadingOverlay, {
            visible: cargando.value,
            message: "Cargando banco de preguntas…"
          }, null, 8, ["visible"]),
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "banco-titulo" }, "Banco de Preguntas", -1)),
            (_ctx.nombreComponente)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _cache[2] || (_cache[2] = _createTextVNode(" Componente: ")),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.nombreComponente), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((busqueda).value = $event)),
              type: "text",
              placeholder: "Buscar por enunciado…",
              class: "banco-input"
            }, null, 512), [
              [_vModelText, busqueda.value]
            ])
          ]),
          (!cargando.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (preguntasFiltradas.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No hay preguntas disponibles en el banco. "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(preguntasFiltradas.value, (p) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: p.id_pregunta,
                    class: _normalizeClass(["banco-item", { 'banco-item--sel': seleccionadas.value.has(p.id_pregunta!) }])
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      class: "banco-check",
                      checked: seleccionadas.value.has(p.id_pregunta!),
                      onChange: ($event: any) => (toggleSeleccion(p))
                    }, null, 40, _hoisted_8),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(p.enunciado || p.pregunta), 1),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(etiquetaTipo(p.tipo_respuesta || p.tipo || '')), 1),
                      (p.opciones?.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.opciones, (op, i) => {
                              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(op), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (p.grupo_interes?.nombre)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Grupo: " + _toDisplayString(p.grupo_interes.nombre), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(seleccionadas.value.size) + " seleccionada(s)", 1),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: "btn salir",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, "Cancelar"),
              (_unref(authStore).tienePermiso('banco.gestionar'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn guardar",
                    disabled: seleccionadas.value.size === 0,
                    onClick: confirmar
                  }, " Agregar seleccionadas ", 8, _hoisted_17))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})